import { Component } from '@angular/core';
import { IQuestionAnswer, faq_model } from '@app/faq/faq-model';

@Component({
    selector: 'app-faq-questions',
    templateUrl: './faq-questions.component.html',
    styleUrls: ['./faq-questions.component.scss']
})
export class FaqQuestionsComponent {
    public panelOpenState: boolean = false;
    public questionAnswers: Array<IQuestionAnswer> = faq_model;
}
